export const videoLazyLoader = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const lazyVideos = [...document.querySelectorAll('video.lazy-load')];

        if ('IntersectionObserver' in window) {
            const lazyVideoObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        for (const source in video.target.children) {
                            const videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }

                        if (video.target.dataset.poster) {
                            video.target.poster = video.target.dataset.poster;
                        }

                        try {
                            video.target.load();
                        } catch {
                            // Do nothing
                        }
                        video.target.classList.remove('lazy-load');
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });

            lazyVideos.forEach(function (lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        } else {
            lazyVideos.forEach(function (video) {
                for (const source in video.children) {
                    const videoSource = video.children[source];
                    if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                        videoSource.src = videoSource.dataset.src;
                    }
                }

                video.load();
                video.classList.remove('lazy-load');
            });
        }
    });
};
